var map = {
	"./WhatsApp Image 2025-01-30 at 1.36.00 PM (1).jpeg": 62343,
	"./WhatsApp Image 2025-01-30 at 1.36.00 PM.jpeg": 61329,
	"./WhatsApp Image 2025-01-30 at 1.36.01 PM (1).jpeg": 33710,
	"./WhatsApp Image 2025-01-30 at 1.36.01 PM.jpeg": 85812,
	"./WhatsApp Image 2025-01-30 at 1.36.02 PM.jpeg": 71035
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5570;